import { Chip, Grid, Typography } from '@mui/material'
import React from 'react'
import PersonIcon from '@mui/icons-material/Person';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';

export const LeyendaRecolectores = () => {
    return (
        <Grid
            container
            direction="row"
            justifyContent="start"
            alignItems="end"
            size={{ xs: 12 }}
            spacing={2}
        >
            <Typography variant='body2'>
                <PersonIcon sx={{ mb: -0.5, fontSize: 25 }} color='primary' /> Sin comprobar.
            </Typography>

            <Typography variant='body2'>
                <PersonIcon sx={{ mb: -0.5, fontSize: 25 }} color='secondary' /> Comprobación correcta.
            </Typography>

            <Typography variant='body2'>
                <PersonIcon sx={{ mb: -0.5, fontSize: 25 }} color='error' /> Comprobación erronea.
            </Typography>

            <Typography variant='body2'>
                <Chip icon={<SensorOccupiedIcon />} label="0.0/10.0" size="small" /> Nota comprobación.
            </Typography>

        </Grid>
    )
}
